import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import axios from 'axios';
import moment from 'moment';

let requestIndicadorGastosVentas = axios.CancelToken.source();
let requestIndicadoresGastosVentasHistorico = axios.CancelToken.source();
let requestIndicadorComprasVentas = axios.CancelToken.source();
let requestIndicadoresComprasVentasHistorico = axios.CancelToken.source();


const state = {
    indicadorGastos: {},
    indicadoresGastosHistorico: [],
    indicadorGastosComprobantes: [],
    indicadorGastosInicializado: false,
    
    indicadorComprasVentas: {},
    indicadorComprasVentasInicializado: false,
    indicadorGastosVentas: {},
    indicadorGastosVentasInicializado: false,
    indicadoresComprasVentasHistorico: [],
    indicadoresGastosVentasHistorico: [],

    indicadorRSE: {},
    indicadoresRSEHistorico: [],

    resultadosIndicadorPlazosProveedoresComprobantes: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_INDICADORES' (state) {
        state.indicadorGastos = {};
        state.indicadorGastosInicializado = false;
        // state.indicadorRSE = {};
        state.indicadorComprasVentas = {};
        state.indicadorComprasVentasInicializado = false;
        state.indicadorGastosVentas = {};
        state.indicadorGastosVentasInicializado = false;
    },
    'SET_INDICADOR_GASTOS'(state, indicador) {
        state.indicadorGastos = indicador;
        state.indicadorGastosInicializado = true;
    },
    'INICIALIZAR_INDICADOR_RSE' (state) {
        state.indicadorRSE = {};
    },
    'SET_INDICADOR_RSE'(state, indicador) {
        state.indicadorRSE = indicador;
    },

    'INICIALIZAR_INDICADOR_COMPRAS_VENTAS' (state) {
        state.indicadorComprasVentas = {};
        state.indicadorComprasVentasInicializado = false;
    },
    'SET_INDICADOR_COMPRAS_VENTAS'(state, indicador) {
        state.indicadorComprasVentas = indicador;
        state.indicadorComprasVentasInicializado = true;
    },
    'INICIALIZAR_INDICADOR_GASTOS_VENTAS' (state) {
        state.indicadorGastosVentas = {};
        state.indicadorGastosVentasInicializado = false;
    },
    'SET_INDICADOR_GASTOS_VENTAS'(state, indicador) {
        state.indicadorGastosVentas = indicador;
        state.indicadorGastosVentasInicializado = true;
    },
    
    'INICIALIZAR_INDICADORES_HISTORICO' (state) {
        state.indicadoresGastosHistorico = [];
        state.indicadoresRSEHistorico = {};
    },
    'SET_INDICADORES_GASTOS_HISTORICO'(state, indicadores) {
        state.indicadoresGastosHistorico = indicadores;
    },
    'SET_INDICADORES_RSE_HISTORICO'(state, indicadores) {
        state.indicadoresRSEHistorico = indicadores;
    },

    'INICIALIZAR_INDICADORES_COMPRAS_VENTAS_HISTORICO' (state) {
        state.indicadoresComprasVentasHistorico = {};
    },
    'SET_INDICADORES_COMPRAS_VENTAS_HISTORICO'(state, indicadores) {
        state.indicadoresComprasVentasHistorico = indicadores;
    },

    'INICIALIZAR_INDICADOR_GASTOS_COMPROBANTES' (state) {
        state.indicadorGastosComprobantes = [];
    },
    'SET_INDICADOR_GASTOS_COMPROBANTES'(state, comprobantes) {
        state.indicadorGastosComprobantes = comprobantes;
    },

    'INICIALIZAR_INDICADORES_GASTOS_VENTAS_HISTORICO' (state) {
        state.indicadoresGastosVentasHistorico = {};
    },
    'SET_INDICADORES_GASTOS_VENTAS_HISTORICO'(state, indicadores) {
        state.indicadoresGastosVentasHistorico = indicadores;
    },
};

const getters = {
    getField,

    indicadorGastos(state) {
        return state.indicadorGastos;
    },
    indicadorGastosInicializado(state) {
        return state.indicadorGastosInicializado;
    },
    indicadoresGastosHistorico(state) {
        return state.indicadoresGastosHistorico;
    },
    indicadorGastosComprobantes(state) {
        return state.indicadorGastosComprobantes;
    },

    indicadorRSE(state) {
        return state.indicadorRSE;
    },
    indicadoresRSEHistorico(state) {
        return state.indicadoresRSEHistorico;
    },

    indicadorComprasVentas(state) {
        return state.indicadorComprasVentas;
    },
    indicadorComprasVentasInicializado(state) {
        return state.indicadorComprasVentasInicializado;
    },
    indicadorGastosVentas(state) {
        return state.indicadorGastosVentas;
    },
    indicadorGastosVentasInicializado(state) {
        return state.indicadorGastosVentasInicializado;
    },

    indicadoresComprasVentasHistorico(state) {
        return state.indicadoresComprasVentasHistorico;
    },
    indicadoresGastosVentasHistorico(state) {
        return state.indicadoresGastosVentasHistorico;
    },
};

const actions = {
    inicializar ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADORES');
            resolve();
        })
    },
    getIndicadorGastos ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/gastos')
                .then(res => {
                    commit('SET_INDICADOR_GASTOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadorRSE ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADOR_RSE');

            apiAxios.get('indicadores/rse')
                .then(res => {
                    commit('SET_INDICADOR_RSE', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadorComprasVentas ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADOR_COMPRAS_VENTAS');

            apiAxios.get('indicadores/compras-ventas', { cancelToken: requestIndicadorComprasVentas.token })
                .then(res => {
                    commit('SET_INDICADOR_COMPRAS_VENTAS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    cancelarIndicadorComprasVentas() {
        requestIndicadorComprasVentas.cancel();
        requestIndicadorComprasVentas = axios.CancelToken.source();
    },
    getIndicadorGastosVentas ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADOR_GASTOS_VENTAS');

            apiAxios.get('indicadores/gastos-ventas', { cancelToken: requestIndicadorGastosVentas.token })
                .then(res => {
                    commit('SET_INDICADOR_GASTOS_VENTAS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    cancelarIndicadorGastosVentas() {
        requestIndicadorGastosVentas.cancel();
        requestIndicadorGastosVentas = axios.CancelToken.source();
    },

    inicializarHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADORES_HISTORICO');
            resolve();
        })
    },
    getIndicadoresGastosHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/gastos/historico')
                .then(res => {
                    commit('SET_INDICADORES_GASTOS_HISTORICO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadoresRSEHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/rse/historico')
                .then(res => {
                    commit('SET_INDICADORES_RSE_HISTORICO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    getIndicadorGastosDetalleGastos ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADOR_GASTOS_COMPROBANTES');

            apiAxios.get('indicadores/gastos/gastos')
                .then(res => {
                    commit('SET_INDICADOR_GASTOS_COMPROBANTES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadorGastosDetalleGastosHistorico ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADOR_GASTOS_COMPROBANTES');

            let query = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD');

            apiAxios.get('indicadores/gastos/historico/gastos' + query)
                .then(res => {
                    commit('SET_INDICADOR_GASTOS_COMPROBANTES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadorGastosDetalleOrdenesInternas ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADOR_GASTOS_COMPROBANTES');

            apiAxios.get('indicadores/gastos/ordenes-internas')
                .then(res => {
                    commit('SET_INDICADOR_GASTOS_COMPROBANTES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadorGastosDetalleOrdenesInternasHistorico ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADOR_GASTOS_COMPROBANTES');

            let query = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD');

            apiAxios.get('indicadores/gastos/historico/ordenes-internas' + query)
                .then(res => {
                    commit('SET_INDICADOR_GASTOS_COMPROBANTES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadorGastosDetalleCompras ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADOR_GASTOS_COMPROBANTES');

            apiAxios.get('indicadores/gastos/compras')
                .then(res => {
                    commit('SET_INDICADOR_GASTOS_COMPROBANTES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadorGastosDetalleComprasHistorico ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADOR_GASTOS_COMPROBANTES');

            let query = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD');

            apiAxios.get('indicadores/gastos/historico/compras' + query)
                .then(res => {
                    commit('SET_INDICADOR_GASTOS_COMPROBANTES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    getIndicadoresComprasVentasHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADORES_COMPRAS_VENTAS_HISTORICO');
            apiAxios.get('indicadores/compras-ventas/historico', { cancelToken: requestIndicadoresComprasVentasHistorico.token })
                .then(res => {
                    commit('SET_INDICADORES_COMPRAS_VENTAS_HISTORICO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    cancelarIndicadorComprasVentasHistorico() {
        requestIndicadoresComprasVentasHistorico.cancel();
        requestIndicadoresComprasVentasHistorico = axios.CancelToken.source();
    },
    getIndicadoresGastosVentasHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADORES_GASTOS_VENTAS_HISTORICO');
            apiAxios.get('indicadores/gastos-ventas/historico', { cancelToken: requestIndicadoresGastosVentasHistorico.token })
                .then(res => {
                    commit('SET_INDICADORES_GASTOS_VENTAS_HISTORICO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    cancelarIndicadorGastosVentasHistorico() {
        requestIndicadoresGastosVentasHistorico.cancel();
        requestIndicadoresGastosVentasHistorico = axios.CancelToken.source();
    },    
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}